import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Linares from "../components/Linares";
import SiteMap from "../components/SiteMap";

const Assessoria = () => {
    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // for smoothly scrolling
        });
        
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;

    return (
        <>
            <header>
                <Header isMobile={isMobile} />
            </header>
            <main id="conteudo-principal">
                <h1 className="sr-only">Assessoria de Imprensa</h1>
                <Linares />
            </main>
            <footer>
                <Footer />
                <SiteMap />
            </footer>
        </>
    );
};

export default Assessoria;
